<template>
	<NuxtPage />
</template>
<script lang="ts" setup>
import useSharedApi from '~/api/useSharedApi';
import useBaseApiUrl from '~/composables/useBaseApiUrl';

const baseApiUrl = useBaseApiUrl();
useSharedApi(baseApiUrl);
useNloProvideApi('portal');
</script>
